// Module
var code = "<p>Excel work !!!</p> ";
// Exports
module.exports = code;